import { Request } from '@/classes/Request'
import { Util } from '@/modules/util'
import type { HealthData } from '@/types/health'

export const getHealthData = async (
  healthEProOrgId: number,
  districtId: number,
  healthEProId: number
) => {
  const params = {
    health_e_pro_org_id: healthEProOrgId,
    district_id: districtId,
    health_e_pro_id: healthEProId
  }

  const response = await new Request().get('/ajax/health_epro_data', params)
  return Util.Obj.keysToCamel(response.data.health_data) as HealthData
}
